import { Link } from '@tanstack/react-router';
import {
  Users,
  ArrowLeftRight,
  Landmark,
  MessageSquareWarning,
  IdCard,
  Banknote,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { Container } from '@/components/custom/container';
import { useDashboardContext } from '@/stores/context/dashboard-layout-context';

interface SidebarItem {
  to: string;
  label: string;
  icon: LucideIcon;
  testId: string;
}

const sidebarItems: SidebarItem[] = [
  { to: '/users', label: 'Users', icon: Users, testId: 'sidebar-item-users' },
  { to: '/kyc', label: 'KYC', icon: IdCard, testId: 'sidebar-item-kyc' },
  {
    to: '/transactions',
    label: 'Transactions',
    icon: ArrowLeftRight,
    testId: 'sidebar-item-transactions',
  },
  { to: '/withdrawal', label: 'Withdrawal', icon: Landmark, testId: 'sidebar-item-settlement' },
  {
    to: '/complaint',
    label: 'Dispute',
    icon: MessageSquareWarning,
    testId: 'sidebar-item-complaint',
  },
  {
    to: '/manual-transfer',
    label: 'Manual Transfer',
    icon: Banknote,
    testId: 'sidebar-item-manual-transfer',
  },
];

const SidebarItems = () => {
  const { toggleSidebar } = useDashboardContext();

  return (
    <Container
      direction="column"
      className="overflow-y-auto px-4 pb-2 sm:px-0 sm:pb-0"
      data-testid="sidebar-items"
    >
      {sidebarItems.map(({ to, label, icon: Icon, testId }) => (
        <Link
          key={to}
          to={to}
          activeProps={{
            className: 'text-white delay-100 duration-200 hover:bg-transparent hover:text-white',
          }}
          onClick={toggleSidebar}
          className="hover:text-brand-blue group relative isolate flex min-h-10 items-center gap-3 rounded-md px-3 py-2 text-sm leading-5 font-normal transition-colors duration-100 ease-out hover:bg-blue-50 motion-reduce:transition-none motion-reduce:delay-0"
          data-testid={testId}
        >
          <span
            aria-hidden="true"
            className="bg-brand-blue pointer-events-none absolute inset-0 -z-10 scale-95 rounded-md opacity-0 transition-[opacity,transform] duration-100 ease-out group-data-[status=active]:scale-100 group-data-[status=active]:opacity-100 group-data-[status=active]:delay-100 group-data-[status=active]:duration-200 motion-reduce:transition-none motion-reduce:delay-0"
          />
          <Icon size={18} className="shrink-0" />
          <span>{label}</span>
        </Link>
      ))}
    </Container>
  );
};

export default SidebarItems;
